(function ($) {
    $(".js-datepicker").datepicker({
        format: "dd.mm.yyyy",
        language: "pl",
    });
})(jQuery);
